import { Component, ChangeDetectionStrategy } from "@angular/core";
import { getApp } from "../app";
import { Subscription } from "rxjs";
import { environment } from "../../environments/environment";

@Component({
    selector: "app-release-notes-banner",
    templateUrl: "./release-notes-banner.component.html",
    styleUrls: ["./release-notes-banner.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReleaseNotesBannerComponent {
  show = false;
  lastVersion = "";
  _bannerSubscription: Subscription = new Subscription();

  app = getApp((app) => {
    this.app = app;
  });

  constructor() {}

  ngOnInit() {
    this._bannerSubscription =
      this.app.releaseNotesBanner.bannerSubject.subscribe((value) => {
        this.show = value;
        this.lastVersion = environment.version;
      });
  }

  ngOnDestroy() {
    if (this._bannerSubscription) {
      this._bannerSubscription?.unsubscribe();
    }
  }
}
